import ApiFetcher2, {BASE_CONFIG} from 'static/three-oh/src/modules/apis/ApiFetcher2';

import ApiFetcher3 from '../ApiFetcher3';

const config = {
  ...BASE_CONFIG,
  basePath: window.AGATHA_URL + '/api/',
  credentials: 'include',
};

class AgathaServiceApi {
  static config = config;

  /*
    We're currently testing out an alternate hosting option (ECS Fargate) for Agatha,
    and while we do we'll need to potentially send users to a different URL while we
    ramp up testing. This is managed via the "target_fargate" parameter, and is handled
    by an Optimizely feature flag in calling functions.
  */

  static _get(endpoint, target_fargate, params) {
    // Until we get fully cutover to ECS, feature environments running off of
    // *.dev.newseladev.com need to make their requests over the monolith proxy.
    // This should be removed post-cutover.
    if (window.location.origin.includes('dev.newseladev.com')) {
      if (endpoint !== 'search/') {
        // The Agatha proxy is in fact split across 3 endpoints. The schema and
        // suggestions endpoints are nested under the primary search route.
        endpoint = 'search/' + endpoint;
      }
      // A proxied call passes through the Monolith's Agatha proxy.
      return ApiFetcher3.get(endpoint, params);
    }

    // We're going to adjust the standard config if we're targeting Fargate.
    // The Fargate version of Agatha is configured to run on same origin as the
    // monolith, just at /agatha. (eg. https://newsela.com/agatha)
    if (target_fargate) {
      config.basePath = `${window.location.origin}/agatha/api/`;
    }
    return ApiFetcher2.get(endpoint, {config, params});
  }

  static getContent(target_fargate, params = {}) {
    return this._get('search/', target_fargate, params);
  }

  static getSchema(target_fargate, params = {}) {
    return this._get('schema/', target_fargate, params);
  }

  static getSuggestions(target_fargate, params = {}) {
    return this._get('suggestions/', target_fargate, params);
  }
}

export default AgathaServiceApi;
